<template>
  <div
    class="
      bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-player-market-us
    ">
    <div
      class="bto-sb-widget-title bto-sb-collapsed"
      :class="{ 'bto-sb-market-cashout': group.hasCashout, 'bto-sb-show': !collapsed }"
      @click="collapse()">
      <i class="bto-app-cash" v-if="group.hasCashout"></i>
      <h3>{{ group.name }}</h3>
      <div class="bto-sb-player-team-legend" v-show="SHOW_TEAM_JERSEYS">
        <span
          ><span class="bto-sb-player-team-jersey bto-sb-player-home"></span
          >{{ match.homeTeam }}</span
        >
        <span
          ><span class="bto-sb-player-team-jersey bto-sb-player-away"></span
          >{{ match.guestTeam }}</span
        >
      </div>
    </div>
    <div class="bto-sb-widget-content" v-if="!collapsed">
      <div class="bto-sb-event-odds-nav" v-if="!group.complexMarket">
        <div class="bto-sb-event-odds-nav-labels">
          <div class="bto-sb-event-odds-left">
            <div class="bto-sb-event-odds-cell">{{ t("BetSlip.Player") }}</div>
          </div>
          <div class="bto-sb-event-odds-right">
            <div class="bto-sb-event-odds-cell">
              <span
                v-for="(market, i) in group.groupedMarkets"
                :key="i"
                class="bto-sb-event-marketlabel"
                >{{ market.marketName }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="bto-sb-market-items">
        <div
          class="bto-sb-event-odds-content"
          v-for="(player, i) in group.playersList.slice(0, rowsToShow)"
          :key="i">
          <div class="bto-sb-event-odds">
            <div class="bto-sb-event-odds-left">
              <div class="bto-sb-event-name">
                <a href="javascript:void(0);" :title="player.name">
                  <div class="bto-sb-event-wrap">
                    <span class="bto-sb-event-team">
                      <span
                        class="bto-sb-player-team-jersey"
                        :class="[playerTeamJersey(player)]"
                        v-if="player.teamEnum && SHOW_TEAM_JERSEYS"></span>
                      <span class="bto-sb-event-info">
                        <span class="bto-sb-event-home">{{ player.name }}</span>
                        <span
                          class="bto-sb-event-description"
                          v-if="SHOW_PLAYER_TEAM_NAME && playerTeam(player)"
                          >{{ playerTeam(player) }}</span
                        >
                      </span>
                    </span>
                  </div>
                </a>
              </div>
            </div>
            <div class="bto-sb-event-odds-right">
              <div class="bto-sb-event-odds-cell">
                <component
                  :is="match.isLiveMatch ? 'match-odd-live-component' : 'match-odd-component'"
                  v-for="(market, i) in group.groupedMarkets"
                  :key="i"
                  :match="match"
                  :odd="market"
                  :outcome="player.markets[market.marketId] || { outcome: '--' }"
                  :isDetails="false"
                  :showEmptyOutcome="true"
                  :lockEmptyOdd="false" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bto-sb-widget-footer" v-if="showMoreButton">
        <a
          href="javascript:void(0);"
          class="bto-sb-more-item"
          :class="{
            'bto-sb-less': showAll,
            'bto-sb-show': !showAll,
          }"
          @click="toggleRows"
          >{{ t(showAll ? "Mobile.ShowLess" : "Mobile.ShowMore") }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../../store";
import MatchOddLiveComponent from "../../../common/match/match-odd-live-component.vue";

export default {
  name: "GroupedPlayerMarketUSComponent",
  components: {
    MatchOddLiveComponent,
  },
  data() {
    return {
      OUTCOME_ROWS_DEFAULT: +APP_SETTINGS.settings.outcomesToShowByDefault,
      showAll: false,
      SHOW_TEAM_JERSEYS: APP_SETTINGS.playerOdds.showTeamJerseys,
      SHOW_PLAYER_TEAM_NAME: APP_SETTINGS.playerOdds.showPlayerTeamName,
      collapsed: false,
    };
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    match: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rowsToShow() {
      return (!this.showAll && this.OUTCOME_ROWS_DEFAULT) || Infinity;
    },
    showMoreButton() {
      if (!this.OUTCOME_ROWS_DEFAULT) {
        return false;
      }
      return this.group.playersList.length > this.OUTCOME_ROWS_DEFAULT;
    },
    is3WaySport() {
      const sid = (this.match && this.match.sportId) || -1;
      return store.getters.getSportType(sid) === 3;
    },
  },
  methods: {
    playerTeamJersey(player) {
      if (!player.teamEnum) {
        return "";
      }
      return player.teamEnum === 1 ? "bto-sb-player-home" : "bto-sb-player-away";
    },
    playerTeam(player) {
      if (!player.teamEnum || !this.match) {
        return "";
      }
      return player.teamEnum === 1 ? this.match.homeTeam : this.match.guestTeam;
    },
    toggleRows() {
      this.showAll = !this.showAll;
    },
    collapse() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>